<template>
  <management-page :pageName="pageName" :menu="menu" class="management" />
</template>

<script>
import { mapActions } from "vuex";
import { managementViewMixin } from "@/mixins/management/managementViewMixin";
import ManagementPage from "@/components/Management/Management";

import BusinessCenter from "@/assets/management/business_center.svg";

export default {
  name: "SimulationsManagement",

  components: {
    ManagementPage
  },

  mixins: [managementViewMixin],

  computed: {
    /**
     * Determine the page title
     * @returns {VueI18n.TranslateResult}
     */
    pageName() {
      return this.$i18n.t("SimulationManagement");
    },

    /**
     * Determines the menu available in the sidebar on the page
     * @returns {[{submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: string, disabled: boolean}, {route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}, {route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}, {route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}], name: VueI18n.TranslateResult, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}]}
     */
    menu() {
        return [
          {
            name: this.$i18n.t("Simulations"),
            icon: BusinessCenter,
            disabled: false,
            submenu: [
              {
                name: this.$i18n.t("Npv"),
                route: "npv",
                disabled: !this.userHasManagementPermission("workspace_list"),
                dev: false
              },
            ]
          },
          {
            name: this.$i18n.t("Configuration"),
            icon: BusinessCenter,
            disabled: false,
            route: "simulations",
            submenu: [
              {
                name: this.$i18n.t("Npv"),
                route: "configuration-npv",
                disabled: !this.userHasManagementPermission("workspace_list"),
                dev: false
              },
            ]
          }
        ];
    }
  },

  created() {
    if (this.userHasFibercloudPermission("list_list")) {
      this.GET_ALL_LISTS();
    }
    if (this.$store.getters.getAllObjectTypesProperties.length === 0) {
      this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
    }
  },

  methods: {
    ...mapActions([
      "FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS",
      "GET_ALL_LISTS"
    ]),

    /**
     * Checks if admin has permissions to enter the Delete Submenu in sidebar
     * SuperAdmin always has permission to delete.
     */
    userHasPermissionDelete() {
      if (this.isAdmin) {
        for (let permission of this.roleManagementPermissions) {
          if (permission.action_type === "delete_validation") {
            let permissionSet = permission.permission_set;
            if (this.userHasPermissionDeleteDestroy(permissionSet)) {
              return true;
            }
          }
        }
      }

      return this.isSuperAdmin;
    },

    userHasPermissionDeleteDestroy(permissionSet) {
      for (let permission of this.roleManagementPermissions) {
        if (
          permission.action_type === "delete_destroy" &&
          permission.permission_set === permissionSet
        ) {
          return true;
        }
      }
      return this.isSuperAdmin;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Npv.vue